import Application from './Application';
import Managers from '../Managers/Constants/Managers';
var ContentViewModel = /** @class */ (function () {
    /* MANAGERS */
    /*protected _navigationManager : NavigationManager;
    protected _popupManager : PopUpManager;
    protected _translationManager : TranslationManager;
    protected _languageManager : LanguageManager;
    protected _moduleManager : ModuleManager;*/
    /* CONSTRUCTOR */
    function ContentViewModel(view) {
        var _this = this;
        /* ATTRIBUTES */
        this.isMounted = false;
        this._view = view;
        this.state = function () { return _this.getState(); };
        this.props = function () { return _this.getProps(); };
        this.style = function () { return _this.getStyle(); };
        /*this._navigationManager = Application.current.resolve<NavigationManager>(Managers.NAVIGATION_MANAGER);
        this._popupManager = Application.current.resolve<PopUpManager>(Managers.POPUP_MANAGER);
        this._languageManager = Application.current.resolve<LanguageManager>(Managers.LANGUAGE_MANAGER);
        this._translationManager = Application.current.resolve<TranslationManager>(Managers.TRANSLATION_MANAGER);
        this._moduleManager = Application.current.resolve<ModuleManager>(Managers.MODULE_MANAGER);*/
    }
    /* COMPONENT EVENTS */
    ContentViewModel.prototype.componentDidUpdate = function () { };
    ContentViewModel.prototype.onBackground = function (nextState) { };
    ContentViewModel.prototype.componentDidMount = function () { };
    ContentViewModel.prototype.componentWillUnmount = function () { };
    ContentViewModel.prototype.shouldComponentUpdate = function () { return true; };
    ContentViewModel.prototype.OnBackAndroidPressed = function () {
        return true && Application.current.resolve(Managers.NAVIGATION_MANAGER).navigateToPrevious({}, 1);
    };
    ContentViewModel.prototype.setOnBackAndroidPressed = function (handler) {
        this._view.setBackHandler(handler);
    };
    ContentViewModel.prototype.removeBackHandler = function (handler) {
        this._view.removeBackHandler(handler);
    };
    /* METHODS */
    // Used to call the setstate of the binded view
    ContentViewModel.prototype.setField = function (state, callBack) {
        if (this.isMounted) {
            this._view.setState(state, callBack);
        }
        else {
            console.warn('Tried to update an unmounted component.');
        }
    };
    // used to set the initial state of the binded view
    ContentViewModel.prototype.initialState = function (state) {
        this._view.state = state;
    };
    ContentViewModel.prototype.getState = function () {
        return this._view.state;
    };
    ContentViewModel.prototype.getProps = function () {
        return this._view.props;
    };
    ContentViewModel.prototype.getStyle = function () {
        return this._view.style;
    };
    /* TRANSLATION */
    ContentViewModel.prototype.translate = function (key, upper) {
        if (upper === void 0) { upper = false; }
        if (upper) {
            return Application.current.resolve(Managers.TRANSLATION_MANAGER).translateUpperCase(key, Application.current.resolve(Managers.LANGUAGE_MANAGER).language);
        }
        return Application.current.resolve(Managers.TRANSLATION_MANAGER).translate(key, Application.current.resolve(Managers.LANGUAGE_MANAGER).language);
    };
    /* NAVIGATION */
    ContentViewModel.prototype.route = function () {
        return Application.current.resolve(Managers.NAVIGATION_MANAGER).route;
    };
    ContentViewModel.prototype.parameters = function () {
        return Application.current.resolve(Managers.NAVIGATION_MANAGER).parameters();
    };
    ContentViewModel.prototype.navigate = function (route, shouldPush, data, clear) {
        if (shouldPush === void 0) { shouldPush = true; }
        var tmp = +"/" + route;
        if (this._view.props != undefined && this._view.props.module != undefined) {
            tmp = "/" + this._view.props.module + "/" + route;
        }
        Application.current.resolve(Managers.NAVIGATION_MANAGER).navigate(tmp, shouldPush, data, clear);
    };
    ContentViewModel.prototype.navigateToModule = function (moduleId, shouldPush, data, clear) {
        if (shouldPush === void 0) { shouldPush = true; }
        var theModule = Application.current.resolve(Managers.MODULE_MANAGER).resolveModuleById(moduleId);
        if (theModule != undefined) {
            Application.current.resolve(Managers.NAVIGATION_MANAGER).navigate('/' + theModule, shouldPush, data, clear);
        }
        else {
            console.warn('This module is not defined : ' + moduleId);
        }
    };
    ContentViewModel.prototype.navigateToModulePage = function (moduleId, page, shouldPush, data, clear) {
        if (shouldPush === void 0) { shouldPush = true; }
        var theModule = Application.current.resolve(Managers.MODULE_MANAGER).resolveModuleById(moduleId);
        if (theModule != undefined) {
            Application.current.resolve(Managers.NAVIGATION_MANAGER).navigate('/' + theModule + "/" + page, shouldPush, data, clear);
        }
        else {
            console.warn('This module is not defined : ' + moduleId);
        }
    };
    ContentViewModel.prototype.navigateToPrevious = function (numberPreviousPage, data) {
        Application.current.resolve(Managers.NAVIGATION_MANAGER).navigateToPrevious(data, numberPreviousPage);
    };
    ContentViewModel.prototype.navigateToRoot = function (route, data, clear) {
        if (route === void 0) { route = ''; }
        Application.current.resolve(Managers.NAVIGATION_MANAGER).navigateToRoot(route, data, clear);
    };
    /* POP UPS */
    ContentViewModel.prototype.showPopUp = function (element, startCallback, time, endCallback) {
        Application.current.resolve(Managers.POPUP_MANAGER).showPopUp(element, startCallback, time, endCallback);
    };
    ContentViewModel.prototype.closePopUp = function () {
        Application.current.resolve(Managers.POPUP_MANAGER).closePopUp();
    };
    /* Toast */
    ContentViewModel.prototype.showToast = function (element, startCallback, time, endCallback) {
        Application.current.resolve(Managers.TOAST_MANAGER).showToast(element, startCallback, time, endCallback);
    };
    ContentViewModel.prototype.closeToast = function (callback) {
        Application.current.resolve(Managers.TOAST_MANAGER).closeToast(callback);
    };
    return ContentViewModel;
}());
export default ContentViewModel;
